import Env from '../base/env';
import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
      main: document.querySelector('main'),
    };

    this.DOM.main.style.opacity = 1;

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        Env.$html.classList.remove('page-leaving');
      }
    });

    window.addEventListener('pagehide', () => {
      if (Env.mobileCSS) {
        Env.$html.classList.remove('page-leaving');
      }
    });
    //? Transition Out
    window.addEventListener('beforeunload', () => {
      Env.$html.classList.add('page-leaving');
    });
  }
}
